import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconClose.tsx
const OutlinedFilledClose = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m249-183-66-66 231-231-231-231 66-66 231 231 231-231 66 66-231 231 231 231-66 66-231-231-231 231Z" })
});
const OutlinedClose = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m249-183-66-66 231-231-231-231 66-66 231 231 231-231 66 66-231 231 231 231-66 66-231-231-231 231Z" })
});
const RoundedFilledClose = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-414 282-216q-14 14-33 14t-33-14q-14-14-14-33t14-33l198-198-198-198q-14-14-14-33t14-33q14-14 33-14t33 14l198 198 198-198q14-14 33-14t33 14q14 14 14 33t-14 33L546-480l198 198q14 14 14 33t-14 33q-14 14-33 14t-33-14L480-414Z" })
});
const RoundedClose = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-414 282-216q-14 14-33 14t-33-14q-14-14-14-33t14-33l198-198-198-198q-14-14-14-33t14-33q14-14 33-14t33 14l198 198 198-198q14-14 33-14t33 14q14 14 14 33t-14 33L546-480l198 198q14 14 14 33t-14 33q-14 14-33 14t-33-14L480-414Z" })
});
const SharpFilledClose = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m249-183-66-66 231-231-231-231 66-66 231 231 231-231 66 66-231 231 231 231-66 66-231-231-231 231Z" })
});
const SharpClose = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m249-183-66-66 231-231-231-231 66-66 231 231 231-231 66 66-231 231 231 231-66 66-231-231-231 231Z" })
});
const componentMap = {
	outlined: OutlinedClose,
	"outlined-fill": OutlinedFilledClose,
	rounded: RoundedClose,
	"rounded-fill": RoundedFilledClose,
	sharp: SharpClose,
	"sharp-fill": SharpFilledClose
};
const IconClose = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconClose };